import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Rejects values that are present but only whitespace. Angular's
 * `Validators.required` treats "   " as filled, so a blank-looking name would
 * otherwise pass. This surfaces the same `required` error so existing
 * "This field is required" messages render unchanged.
 *
 * Only flags non-empty whitespace — an empty value is left to
 * `Validators.required` so the two validators don't produce duplicate errors.
 */
export const notBlankValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = control.value;
  if (typeof value !== 'string' || value.length === 0) {
    return null;
  }
  return value.trim().length === 0 ? { required: true } : null;
};
